import { articleTypeApi } from '@/axios/articleType';
import PaginationSelector from './PaginationSelector';

type Params = Omit<Parameters<typeof articleTypeApi.list>[0], 'pageIndex' | 'pageSize'>;

// 提取 records 数组元素的类型
type TaskRecord = Awaited<ReturnType<typeof articleTypeApi.list>>['records'][number];

/** 用户选择器 */
const ArticleTypeSelector = ({
  params,
  placeholder = '请选择文章类型',
  value,
  onChange,
  multiple = false,
  style,
  defaultOptions = [],
}: {
  params?: Params;
  placeholder?: string;
  value?: string | string[];
  onChange?: (value: string | string[]) => void;
  multiple?: boolean;
  style?: React.CSSProperties;
  /** 默认选项列表，用于在第一页找不到数据时的回显 */
  defaultOptions?: Array<{ label: string; value: string }>;
}) => {
  return (
    <PaginationSelector<TaskRecord, Params>
      fetchApi={(params) => articleTypeApi.list(params)}
      params={params}
      optionTransform={(item) => ({
        value: item.typeId,
        label: item.typeName,
      })}
      searchParamKey='typeName'
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      multiple={multiple}
      style={style}
      defaultOptions={defaultOptions}
    />
  );
};
export default ArticleTypeSelector;
